module.exports = __webpack_public_path__ + "img/china.a7a3d8ef.png";